import { Component, Input, OnInit } from '@angular/core';
import { LetterRequestCustomer_History_Interface } from 'src/app/Interface/LetterRequestCustomer_History_Interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-LetterRequestCustomerTreeHistory',
  templateUrl: './LetterRequestCustomerTreeHistory.component.html',
  styleUrls: ['./LetterRequestCustomerTreeHistory.component.scss']
})
export class LetterRequestCustomerTreeHistoryComponent implements OnInit {

  constructor() { }

  BaseUrl:String=environment.BaseUrl

  @Input() DataList_History:Array<LetterRequestCustomer_History_Interface>=[]

  DataList_History_Main:Array<LetterRequestCustomer_History_Interface>=[]

  ngOnInit() {

    this.Push_To_Main(this.DataList_History)

  }


  Push_To_Main(Model:Array<LetterRequestCustomer_History_Interface>){
    for(let item of Model)
    {
      this.DataList_History_Main.push(item)
      this.Push_To_Main(item.detail)
    }
  }

}
